var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39 39",
    style: {
      enableBackground: "new 0 0 39 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#40D9B5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,0C8.7,0,0,8.7,0,19.5C0,30.3,8.7,39,19.5,39C30.3,39,39,30.3,39,19.5C39,8.7,30.3,0,19.5,0z M28.5,13.3 c-0.3,3.1-1.6,10.6-2.2,14c-0.3,1.5-0.8,2-1.3,2c-1.1,0.1-2-0.7-3.1-1.5c-1.7-1.1-2.7-1.8-4.4-2.9c-1.9-1.3-0.7-2,0.4-3.1 c0.3-0.3,5.3-4.8,5.4-5.2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.3-0.1-0.4,0c-0.2,0-2.9,1.9-8.2,5.4c-0.8,0.5-1.5,0.8-2.1,0.8 c-0.7,0-2-0.4-3-0.7c-1.2-0.4-2.2-0.6-2.1-1.3c0-0.4,0.5-0.7,1.5-1.1c5.7-2.5,9.5-4.1,11.4-4.9c5.4-2.3,6.5-2.6,7.3-2.7 c0.2,0,0.5,0,0.8,0.2c0.2,0.2,0.3,0.4,0.3,0.5C28.5,12.6,28.6,13,28.5,13.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2fe7c67071efc39bbccaaf4c770f7495.svg";
export { ForwardRef as ReactComponent };